import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  container: {
    width: 169,
    height: 120,
    marginRight: 20,
    marginBottom: 20,
    paddingTop: 16,
    borderRadius: 13,
    backgroundColor: '#2c3940',
  },
  containerIcon: {
    marginLeft: 5,
    marginBottom: 9.7,
  },
  name: {
    opacity: 0.5,
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.16,
    textAlign: 'left',
    color: '#efefef',
  },
});
